const getPayrollPrice = (empNum) => (empNum === 0 ? 0 : (empNum - 1) * 39 + 79);

export default getPayrollPrice;
